<template>
  <div>
    <form-alert
      :type="alertText.type"
      :message="alertText.message"
      @close="closeFormAlert"
    />
    <v-card>
      <template v-if="this.cadastroRevisado !== 'NAO_REVISADO'">
        <v-card-text class="card-height">
          <v-layout>
            <v-flex xs12>
              <v-flex xs12 text-xs-center>
                Nenhum registro encontrado
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card-text>
      </template>
      <template v-else>
        <template v-if="!this.documentosPreenchidos">
          <v-card-text class="card-height">
            <anexo-list-component
              v-if="documentos.length"
              :documentosSolicitados.sync="documentos"
              :classColuna="'lg4 md6 sm12'"
              :mostraDescricao="true"
              :mostraTitulo="true"
              @send="setUpdateDocumentos"
              @setDocumentosModel="this.enviarDocumento"
            ></anexo-list-component>

            <v-layout v-else>
              <v-flex xs12>
                <v-flex xs12 text-xs-center>
                  Nenhum registro encontrado
                </v-flex>
                <v-flex xs12 text-xs-center>
                  <button
                    class="button jns-button revisao-credito-botao yellow-button"
                    @click="criarDocumentos"
                  >
                    Revisar crédito sem demanda
                  </button>
                </v-flex>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="documentos.length">
              <v-flex md3 offset-md9 sm12 mr-3>
                <button
                  class="button jns-button yellow-button"
                  @click="dialogFollowUp = true"
                >
                  Enviar Documentos
                </button>
              </v-flex>
            </v-layout>
          </v-card-text>
        </template>

        <template v-else>
          <v-flex xs12>
            <button
              class="button jns-button yellow-button"
              @click="this.limparDocumentos"
            >
              Atualizar Documentos
            </button>
          </v-flex>
        </template>
      </template>
    </v-card>

    <v-dialog v-model="documentosSucessoModal" max-width="640px">
      <base-modal>
        <h3>Formulário enviado para análise com sucesso!</h3>
        <v-layout row wrap>
          <v-flex xs4 offset-xs8 pb-0>
            <v-btn
              class="button jns-button yellow-button mt-4"
              @click="fecharModalSucesso()"
              >OK</v-btn
            >
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>

    <v-dialog
      persistent
      max-height="600px"
      min-height="500px"
      max-width="640px"
      v-model="dialogFollowUp"
    >
      <v-card class="box-card-follow-up">
        <v-container grid-list-xl>
          <v-card-title class="box-card-follow-up-title">
            <h2>
              Prezado corretor, por favor, preencha o e-mail para contato.
            </h2>
          </v-card-title>

          <v-form v-model="validFollowUp">
            <v-text-field
              class="jns-input"
              v-model="inputEmail"
              label="Email"
              :rules="[rules.email]"
              v-on:keyup.enter="keyUpEnterSetEmailFollowUp()"
            ></v-text-field>
          </v-form>

          <v-card-actions class="box-card-follow-up-buttons">
            <v-btn
              class="jns-button white-button"
              @click="dialogFollowUp = false"
              id="voltar"
              >Voltar</v-btn
            >
            <v-btn
              class="jns-button yellow-button"
              @click.prevent="setEmailFollowUp()"
              :disabled="!validFollowUp"
            >
              Solicitar Análise
              <v-icon>arrow_right_alt</v-icon>
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="js">
import { eventBus } from "../main";
import { mapActions } from "vuex";
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "TomadorDocumentos",
  mixins: [ViewMixin],

  data() {
    return {
      rules: {
        obrigatorio: (v) => !!v || this.disabledValidation || "Campo obrigatório",
        email: (v) => !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail inválido"
      },
      documentos: [],
      dialogFollowUp: false,
      validFollowUp: false,
      inputEmail: "",
      documentosSucessoModal: false
    };
  },
  props: ["idTomador", "documentosSolicitados", "idProposta", "idProduto", "documentosPreenchidos", "cadastroRevisado"],
  methods: {
    ...mapActions(["POST_TOMADOR_DOCUMENTOS"]),
    async enviarDocumento(dataDocumentos) {
      if (dataDocumentos && dataDocumentos.length) {
        let response;
        let sendSuccess = false;
        try {
          this.showLoadingAskWait();
          response = await this.POST_TOMADOR_DOCUMENTOS({
            documentos: dataDocumentos,
            idTomador: +this.idTomador,
            email: this.inputEmail
          });
          sendSuccess = true;

        } catch (e) {
          this.defaultHandlerError(e);
        } finally {
          this.hideLoadingAskWait();
        }

        if (sendSuccess) {
          this.documentosSucessoModal = true;
        }
      }
    },

    async limparDocumentos() {
      this.showLoadingAskWait();

      let payload = {
          id: this.idTomador,
        };

      try {
        this.$store
          .dispatch("POST_LIMPAR_DOCUMENTOS", payload)
          .then((response) => {
            window.location.reload();
          })
          .catch(this.handleError);
      } catch (e) {
        this.defaultHandlerError(e);
      }
    },
    async criarDocumentos() {
      let payload = {
          id: this.idTomador,
        };
      try {
      this.showLoadingAskWait();
        this.$store
          .dispatch("CRIAR_DOCUMENTOS_TOMADOR", payload)
          .then((response) => {
            window.location.reload();
          })
          .catch(this.handleError);
      } catch (e) {
        this.defaultHandlerError(e);
      }
    },
    setUpdateDocumentos(data) {
      this.documentos = data;
      this.$forceUpdate();
    },

    validaAnexos() {
      var isValid = true;

      this.documentos.forEach((categoria) => {
        if (categoria.listagem && categoria.listagem.length) {
          for (var i = 0; i < categoria.listagem.length; i++) {
            if (
              (!categoria.listagem[i].arquivos ||
                !categoria.listagem[i].arquivos.length) &&
              categoria.listagem[i].obrigatorio
            )
              isValid = false;
          }
        }
      });
      if (!isValid) eventBus.$emit("validaAnexos");
      else eventBus.$emit("setModelAnexos");

      return isValid;
    },
    fecharModalSucesso() {
      window.location.reload();
    },

    async setEmailFollowUp(){
      localStorage.setItem('@email_folow_up', this.inputEmail);
      this.dialogFollowUp = false;
      this.validaAnexos();
    },

    async keyUpEnterSetEmailFollowUp(){
      if(this.validFollowUp){
        this.setEmailFollowUp();
      }
    },

  },

  created() {
    this.documentos = this.documentosSolicitados
      ? JSON.parse(JSON.stringify(this.documentosSolicitados))
      : [];
  },
};
</script>

<style lang="scss" scoped>
.v-card__title {
  background-color: #efefef;
  font-size: 14px;
  font-weight: bolder;
  color: #191737;
  margin-bottom: 20px;
}

.card-height {
  max-height: 62vh;
  overflow: auto;
}

.box-card-follow-up {
  color: #282498;
  width: 100%;
  margin: 0;
  padding: 0;

  .box-card-follow-up-title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 0 0 2rem 0;
    padding: 0;
  }

  .revisao-credito-botao {
    text-align: center;
    margin: 2rem 0 0 0;
    width: auto !important;
  }

  .box-card-follow-up-buttons {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin: 2rem 0 0 0;
    padding: 10;

    .jns-button {
      margin: 0;
      padding: 0;
      width: 48%;
    }

    .jns-button:nth-of-type(2) {
      margin-left: 10px;
    }
  }

  @media screen and (max-width: 451px) {
    .box-card-follow-up-title {
      margin-bottom: 2rem;
    }

    .box-card-follow-up-buttons {
      flex-direction: column;
      margin-top: 1rem;

      .jns-button {
        width: 100%;
        margin: 0.5rem 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/TomadorDocumentos.vue